export default __webpack_public_path__ + "static/media/caller.06aaae9d.svg";